import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { SayfalamaSonuc } from '@models_genel/SayfalamaSonuc';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
import { KntSiparisInfo } from '@core/models/kontor-siparis/KntSiparisInfo';
import { ArdventureKntSiparisInfo } from '@core/models/kontor-siparis/ArdventureKntSiparisInfo';
import { KntKontorPaketInfo } from '@core/models/kontor-siparis/KntKontorPaketInfo';


@Injectable()
export class KontorSiparisService {

	constructor(private http: HttpClient) {
	}

	// Kontör sipariş
	ekleGuncelle(kontorSiparisInfo: KntSiparisInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KONTOR_SIPARIS_URL, kontorSiparisInfo);
	}

	// Kontör sipariş
	validasyonYap(kontorSiparisInfo: KntSiparisInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KONTOR_SIPARIS_URL + 'validasyonyap/', kontorSiparisInfo);
	}
	ardventureKontorSiparis(ardventureSiparisInfo: ArdventureKntSiparisInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KONTOR_SIPARIS_URL + 'ardventureKontorSiparis/', ardventureSiparisInfo);
	}
	// Kontör sipariş
	select(siparisId: number): Observable<KntSiparisInfo> {
		return this.http.get<KntSiparisInfo>(environment.API_KONTOR_SIPARIS_URL + siparisId.toString());
	}

	// Kontör sipariş
	selectKontorPaket(kontorPaketId: number): Observable<KntKontorPaketInfo> {
		return this.http.get<KntKontorPaketInfo>(environment.API_KONTOR_SIPARIS_URL + 'selectkontorpaket/' + kontorPaketId.toString());
	}

	// Kontör sipariş
	getData(aramaKriter?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_KONTOR_SIPARIS_URL, { params: aramaKriter });
	}

	// Kontör sipariş
	sil(id: number): Observable<any> {
		return this.http.delete<any>(environment.API_KONTOR_SIPARIS_URL + id.toString());
	}

	// Kontör paketleri
	getKontorPaketleri(aramaKriter?: any): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_KONTOR_SIPARIS_URL + 'kontorpaketleri/', aramaKriter);
	}

	// Kontör paketleri
	ekleGuncelleKontorPaket(kontorPaketInfo: KntKontorPaketInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_KONTOR_SIPARIS_URL + 'kontorpaketekleguncelle/', kontorPaketInfo);
	}

	// Kontör paketleri
	silKontorPaket(id: number): Observable<any> {
		return this.http.delete<any>(environment.API_KONTOR_SIPARIS_URL + 'kontorpaketsil/' + id.toString());
	}

	// Kontör paketleri + Kontör sipariş detay
	getKontorRapor(aramaKriter?: any): Observable<any> {
		return this.http.get<any>(environment.API_KONTOR_SIPARIS_URL + 'kontorraporu', { params: aramaKriter });
	}


	getKontorPaketleriWithBuroId(): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_KONTOR_SIPARIS_URL + 'kontorpaketleriByBuroId', null);
	}

	getKontorRaporu(aramaKriter?: any): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'kontorraporulistele', aramaKriter);
	}

	kontorRaporuExport(Kriter: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'kontorraporuexport/', Kriter);
	}
}
